var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#A2A5B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.36 5V10.616H9.992V7.248L8.736 10.616H7.632L6.368 7.24V10.616H5V5H6.616L8.192 8.888L9.752 5H11.36Z",
    fill: "#A2A5B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockup);
export default __webpack_public_path__ + "static/media/mockup.2419a02d45082051bd78f626948d92f6.svg";
export { ForwardRef as ReactComponent };